// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__220w-bifacial-solar-panel_productcontent__k7QrC"};